import React from 'react';
import { NavLink } from 'react-router-dom';
import Header4 from './../Common/Header4';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import { getImageUrl, devitems, generateSlug, STORAGE_KEY } from './../Common/Helpers';
//import Filtros from '../Elements/Filtros';
import { Helmet } from 'react-helmet-async';
import withRouterData from '../Common/withRouterData';
import SearchableGrid from '../Elements/SearchableGrid';
import Swal from 'sweetalert2';
import BotonEnlace from './BotonEnlace';
//import { initializeIsotopeGrid, refreshIsotopeLayout, applyIsotopeFilter, destroyIsotopeGrid } from './../Elements/customFiltros';

const filters = [
    { label: "Hombres", filter: ".Masculino" },
    { label: "Mujeres", filter: ".Femenino" },
    { label: "2025", filter: ".2025" },
    { label: "2024", filter: ".2024" },
    { label: "2023", filter: ".2023" },
    { label: "2022", filter: ".2022" },
    // { label: "Pandilleros", filter: ".cat-5" }
];


var bnrimg = require('./../../images/banner/bg-fichas.jpg');
var bgimg1 = require('./../../images/background/cross-line.png');
const JSON_URL = './data/victregimen.json';
const ITEMS_PER_LOAD = 25;
const GRID_SELECTOR = '.masonry-outer';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    customClass: {
        popup: 'toast-popup',
        title: 'toast-title',
        icon: 'toast-icon',
        timerProgressBar: "toast-progressbar"
    },
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
})



class ProjectGrid5 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [], // Todos los proyectos cargados de la API
            itemsToShow: ITEMS_PER_LOAD, // Inicialmente solo mostramos 8
            loading: true,
            error: null,
            scriptStatus: "Esperando inicio de carga de script..."
        };
        // Referencia para la inicialización del grid (Masonry/Isotope)
        this.gridRef = React.createRef();
    }

    componentDidMount() {

/*         try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(devitems));
            //console.log("✅ Fichas guardados en localStorage.");
        } catch (error) {
            console.error("Error al guardar proyectos:", error);
        } */

        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };
        this.setState({ loading: false });
        this.setState({ data: devitems });
        loadScript('./assets/js/custom.js');
        this.initializeGrid();
        //this.fetchProjectData();
        //initializeIsotopeGrid(GRID_SELECTOR); 
        //

    };

    /*      handleUpdateDevItem = (newDevItemsArray) => {
            const {data:items} = this.state;
    
            //console.info(data);arr1.length !== arr2.length)
            if(newDevItemsArray.length != items.length){
    
                console.info("Cargamos NewArrya");
                this.setState({ data: newDevItemsArray });
                //refreshIsotopeLayout(GRID_SELECTOR);
                ///this.destroyIsotopeGrid();
                //this.initializeGrid(); 
            }else{
                console.info("es igual  newArray"); 
                //this.destroyIsotopeGrid();
                            
    
            }
            //initializeIsotopeGrid(GRID_SELECTOR);
            
            //
    
            
        };  */

    handleUpdateDevItem = (newDevItemsArray, sQuery) => {

        //console.info("Cargamos NewArrya");
        //console.info(newDevItemsArray)
        this.setState({ data: newDevItemsArray });
        //this.initializeGrid();
        this.scrollToResults();
        this.sweeToast(newDevItemsArray);

    }

    sweeToast = (flelments, mesg = "") => {
        let tam = flelments.length;
        mesg = `<span>Resultados de la búsqueda ${tam}</span>`;
        if (flelments.length == 0) {
            mesg = '<h4 class="toast-title">No se entraron resultados </br> con ese criterio </h4>';
        }
        Toast.fire({
            icon: 'info',
            title: mesg,
        });

    }

    componentDidUpdate(prevProps, prevState) {
        // 1. Comparamos la ubicación anterior con la ubicación actual.
        // Si el pathname es diferente, ¡hubo navegación interna!
        /*         if (prevProps.location.pathname !== this.props.location.pathname) {
        
                    console.log("Navegación detectada. Reinicializando...");
                    // 2. Forzamos la reinicialización de los plugins
                    //this.initializeGrid();
                }
                //console.info(prevState.data);
        
                if (prevState.data === null && this.state.data !== null) {
                    this.scrollToResults();
                }        
         */
    }

    async fetchProjectData() {
        // Marcamos la carga de datos como 'iniciada'
        this.setState({ loading: true });
        try {
            const response = await fetch(JSON_URL);
            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }
            const jsonArray = await response.json();

            // 1. Establecemos los datos
            this.setState({
                data: Array.isArray(jsonArray) ? jsonArray : [],
                loading: false
            }, () => {
                // 2. IMPORTANTE: Llamamos a la función de inicialización del diseño
                // después de que los datos y el DOM se han actualizado.
                //this.initializeGrid(); 
            });

        } catch (err) {
            this.setState({ error: err, loading: false });
        }
    }

    destroyIsotopeGrid() {
        const isotopeInstance = window.jQuery('.masonry-outer');
        isotopeInstance.destroy();
        isotopeInstance = null;
        // console.log("Isotope Grid destruido.");
    }

    scrollToResults = () => {
        if (this.gridRef.current) {
            this.gridRef.current.scrollIntoView({
                behavior: 'smooth', // Hace el scroll suave
                block: 'start'       // Alinea la parte superior del elemento con la parte superior de la ventana
            });
            // console.log("Scroll movido al ancla de resultados.");
        }
    }



    // Dentro de la clase ProjectGrid5

    initializeGrid() {
        // 1. Verifica si el plugin principal (e.g., jQuery, Isotope) está cargado

        // quick search regex

/* 		window.jQuery(window).on("scroll", function() {
			var scroll = window.jQuery(window).scrollTop();
			if (scroll > 900) {
				window.jQuery("a.contactsend").fadeIn(1000);
			} else {
				window.jQuery("a.contactsend").fadeOut(1000);
			}
		}); */

        if (window.jQuery && this.gridRef.current) {

            // 2. Ejecuta el comando de refresco del layout.
            // **ESTE CÓDIGO DEPENDE DEL PLUGIN QUE USES.**

            // Ejemplo A: Si usas Masonry
            // window.jQuery(this.gridRef.current).masonry('reloadItems'); 

            // Ejemplo B: Si usas Isotope
            ///window.jQuery("a.contactsend").hide();

        }

        if (window.jQuery().isotope) {

            // window.jQuery('.masonry-outer').isotope('reloadItems').isotope({ sortBy: 'original-order' });

            var $container = window.jQuery('.masonry-outer').isotope('reloadItems').isotope({ sortBy: 'original-order' });

            $container.imagesLoaded().progress(function () {
                $container.isotope('layout');
            })

            //console.log("-> Layout del Grid de Proyectos ha sido recalculado.");

        }
    }

    // Dentro de la clase ProjectGrid5

    loadMore = () => {
        // 1. Actualiza el estado para mostrar más ítems
        this.setState((prevState) => ({
            // itemsToShow: prevState.itemsToShow + ITEMS_PER_LOAD 
            itemsToShow: prevState.itemsToShow + 30
        }),
            // 2. FUNCIÓN CALLBACK: Este código se ejecuta SÓLO después de que 
            //    React ha terminado de insertar los nuevos 8 divs en el DOM.
            () => {
                // Ejecuta el refresco del plugin aquí
                this.initializeGrid();
                //initializeIsotopeGrid(GRID_SELECTOR); 
            });
    }

    render() {
        const { data: items, loading, error, itemsToShow } = this.state;
/*         var texto = <p>La presente información ha sido extraída de diversas fuentes como medios de comunicación social, redes sociales, familiares de las victimas, instituciones, entre otras.</p>
        var texto2 = <p>No se detalla con exactitud la cantidad de personas fallecidas por no ser dato oficial de parte de la Dirección de Centros Penales, Instituto de Medicina Legal (IML) o Policía Nacional Civil (PNC).</p> */
        var texto = <p>La cifra de personas que han fallecido en las prisiones de El Salvador desde que inició el régimen de excepción, en marzo de 2022, no es oficial. Organizaciones como el Socorro Jurídico Humanitario (SJH) han recopilado al menos 444 casos de personas adultas. También hay cuatro menores de edad, pero sus datos no se han incluido en este sitio.</p>
        var texto2 = <p>Busca por nombre, utiliza los filtros o haz clic en cada fotografía para más detalles. </p>        
        var titulo1 = "MEMORIAL DEL RÉGIMEN: ";
        var titulo2 = "FALLECIDOS EN LAS CÁRCELES DE EL SALVADOR ";
        //console.info(items);

        /*
                                    <p>
                                        La presente información ha sido extraída de diversas fuentes como medios de comunicación social, redes sociales, familiares de las victimas, instituciones, entre otras.
                                    </p>
                                    <p>
                                        No se detalla con exactitud la cantidad de personas fallecidas por no ser dato oficial de parte de la Dirección de Centros Penales, Instituto de Medicina Legal (IML) o Policía Nacional Civil (PNC).                                        
                                    </p>        
        
        */
        // 1. Determinar qué proyectos mostrar (Slice del array)
        const visibleItems = items.slice(0, itemsToShow);

        // 2. Comprobar si hay más proyectos para cargar
        const hasMoreProjects = itemsToShow < items.length;

        if (loading) {
            return <h2>Cargando datos...</h2>;
        }

        if (error) {
            return <p style={{ color: 'red' }}>Error fatal: {error.message}</p>;
        }
        const fullTitle = "Archivo de memoria: víctimas del régimen de excepción de El Salvador | La Prensa Gráfica";
        return (
            <>
{/*             <Helmet>
                    <title>{fullTitle}</title>
                    <meta name="description" content={fullTitle.substring(0, 160)} />
                    <meta property="og:title" content={fullTitle} />
                    <meta property="og:description" content={fullTitle.substring(0, 160)} />                
                <meta property="og:image" content={`https://memoria.laprensagrafica.com${bnrimg}`} />
                <meta property="og:site_name" content="La Prensa Gráfica" />
                

                <meta name="twitter:card" content="Cuenta oficial del periódico La Prensa Gráfica, fundado en 1915 en El Salvador" />
                <meta name="twitter:site" content="@prensagrafica" />                 
            </Helmet> */}
                <Header4 />
                <div className="page-content">
                    <Banner title1={titulo1} title2={titulo2}  pagename="" description={{ texto, texto2 }} bgimage={bnrimg} />

                    {/* SECTION CONTENT START */}
                    <div className="section-full p-tb80 column-grid-4 inner-page-padding">
                        <div className="container">
                            {/* Filter Nav START */}
                            {/*                             <div className="filter-wrap p-b30 text-center">
                                <ul className="filter-navigation masonry-filter clearfix">
                                    <li className="active"><NavLink to={"#"} className="btn from-top" data-filter="*" data-hover="All">All</NavLink></li>
                                    {filters.map((item, index) => (
                                        <li key={index}><NavLink to={"#"} className="btn from-top" data-filter={item.filter} >{item.label}</NavLink></li>
                                    ))}
                                </ul>
                            </div> */}
                            {/*                             <Filtros></Filtros>   */}
                            <SearchableGrid data={devitems} onUpdateItem={this.handleUpdateDevItem}></SearchableGrid>
                            {/* Filter Nav END */}
                            {/* GALLERY CONTENT START */}
                            {/*                             <ul className="masonry-outer mfp-gallery row work-grid clearfix list-unstyled grid-5">
                                {projects.map((item, index) => (
                                    <div key={index} className={`${item.filter} masonry-item col-xl-3  col-lg-4 col-md-6 col-sm-12 m-b30`}>
                                        <div className="sx-box image-hover-block">
                                            <div className="sx-thum-bx">
                                                <img src={item.image} alt="" />
                                            </div>
                                            <div className="sx-info  p-t20 text-white">
                                                <h4 className="sx-tilte"><NavLink to={"/project-detail1"}>{item.title}</NavLink></h4>
                                                <p className="m-b0">{item.address}</p>
                                            </div>
                                            <a className="mfp-link" href={item.image}>
                                                <i className="fa fa-arrows-alt" />
                                            </a>
                                        </div>
                                    </div>
                                ))}
                             </ul> */}
                            <ul className="masonry-outer mfp-gallery row work-grid clearfix list-unstyled grid-5" ref={this.gridRef} style={{ position: 'relative' }}>

                                {/*                                    {visibleItems.map((item, index) => (

                                    
                                ))}   */}

                                {visibleItems.map((item, index) => {
                                    const itemSlug = generateSlug(item.id, item.Nombre);

                                    return (
                                        <div key={index} className={`${item.filter} ${item.filter2} masonry-item col-xl-3  col-lg-4 col-md-6 col-sm-12 m-b30`}
                                            data-nombre={item.Nombre}
                                            data-centropenal={item.centropenal}
                                            data-departamento={item.departamento}
                                        >
                                            <div className="sx-box image-hover-block">
                                                <div className="sx-thum-bx">
                                                    <img src={getImageUrl(item.id + "pearch.jpg", item.SEXO)} alt="" />
                                                </div>
                                                <div className="sx-info  p-t20 text-white">
                                                    <h4 className="sx-tilte"><NavLink to={`/ficha/${itemSlug}`} state={{ projectData: item }} >{item.Nombre} </NavLink></h4>
                                                    {/* <p className="m-b0">{item.clasifdelito}</p> */}
                                                    <p style={{ marginBottom: '1px' }}> <b>Ciudad:</b> {item.regionresidia}, <b>Departamento:</b>  {item.departamento}</p>
                                                    <p style={{ marginBottom: '1px' }}> <b>Fecha de deceso:</b> {item.fechadeceso}</p>
                                                </div>
                                                {/*                                             <a className="mfp-link" href={getImageUrl(item.id + "pearch.jpg")} title={item.Nombre +  '\t \n \n Fecha de deceso: ' + item.fechadeceso}>
                                                                    <i className="fa fa-arrows-alt" />
                                                                </a> */}
                                                <a className="mfp-link" href={`#${item.id}`} title={item.Nombre + '\t \n \n Fecha de deceso: ' + item.fechadeceso}>
                                                    <i className="fa fa-arrows-alt" />
                                                </a>
                                            </div>
                                            <div
                                                id={item.id}
                                                className="mfp-hide" // Clase requerida por Magnific Popup para ocultar
                                                style={{ background: '#f8f6f6ff', padding: '20px', maxWidth: '470px', margin: '0 auto' }}
                                            >
                                                <div className="sx-thum-bx">
                                                    <img src={getImageUrl(item.id + "pearch.jpg", item.SEXO)} alt="" />
                                                </div>
                                                <h4 className="sx-title">{item.Nombre}</h4>
                                                <p style={{ marginBottom: '1px' }}> <b>Ciudad:</b> {item.regionresidia}, <b>Departamento:</b>  {item.departamento}</p>
                                                <p style={{ marginBottom: '1px' }}> <b>Fecha de deceso:</b> {item.fechadeceso}</p>
                                                <p style={{ marginBottom: '1px' }}> <b>Motivo del deceso:</b> {item.motivodeceso}</p>
                                            </div>
                                        </div>
                                    );
                                })}

                            </ul>

                            {/* Botón de Cargar Más */}
                            {hasMoreProjects && (
                                <div className="row m-t30">
                                    <div className="col-lg-12 text-center">
                                        <div className="text-center load-more-btn-outer" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                            <button onClick={this.loadMore} className="site-button-secondry btn-half"><span>Cargar más</span></button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* GALLERY CONTENT END */}

                        </div>
                    </div>
                    {/* SECTION CONTENT END  */}
                    <BotonEnlace url="https://forms.gle/Sox4y78TiGg2waDu8" texto="Abrir Google en Nueva Pestaña" /> 
                </div>

                <Footer />
            </>
        );
    };
};

//export default ProjectGrid5;
export default withRouterData(ProjectGrid5);
